import router from "../router";

export default {
  user: {
    verified: false,
    data: null
  },

  isVerified() {
    return this.user.verified;
  },

  setVerified(state) {
    this.user.verified = state;
  },

  setUser(data) {
    if (data.account) {
      data.accountName = data.account.name1;
      data.accountDescription = data.account.description;
    }
    this.user.data = data;
  },

  getUser() {
    return this.user.data;
  },

  logout(context) {
    context.$loader.startLoading("Map");
    this.setVerified(false);
    router.push({ path: "/" });
  }
};
